import { render, staticRenderFns } from "./leijiyishouqu.vue?vue&type=template&id=b488d280&scoped=true&"
import script from "./leijiyishouqu.vue?vue&type=script&lang=js&"
export * from "./leijiyishouqu.vue?vue&type=script&lang=js&"
import style0 from "./leijiyishouqu.vue?vue&type=style&index=0&id=b488d280&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b488d280",
  null
  
)

export default component.exports